import commitShaFile from '../../__generated__/commitSha.json';

export function getCommitSha(): string {
    return commitShaFile.sha || 'commit-sha-not-set';
}

export function getReactNativeVersion(): string {
    return commitShaFile.reactNativeVersion ?? 'unknown';
}
